// components/PaymentMethodPicker.js
import React from 'react';
import { TextField, MenuItem } from '@material-ui/core';

export default function PaymentMethodPicker({
                                                value,
                                                onChange,
                                                label = 'Phương thức',
                                                options,
                                                fullWidth = true,
                                                margin = 'dense',
                                                ...rest
                                            }) {
    const items = options || [
        { value: 'CASH', label: 'Tiền mặt' },
        { value: 'BANK_TRANSFER', label: 'Chuyển khoản' },
    ];

    // onChange của TextField trả e => e.target.value
    const handleChange = (e) => {
        const v = e.target.value;
        // tương thích với cách bạn đã dùng trước đó (onChange(_, v))
        if (typeof onChange === 'function') onChange(e, v);
    };

    return (
        <TextField
            select
            label={label}
            value={value || ''}
            onChange={handleChange}
            fullWidth={fullWidth}
            margin={margin}
            variant="outlined"
            {...rest}
        >
            {items.map(it => (
                <MenuItem key={it.value} value={it.value}>
                    {it.label}
                </MenuItem>
            ))}
        </TextField>
    );
}
